import { render, staticRenderFns } from "./History.vue?vue&type=template&id=cb49dff8&scoped=true&"
import script from "./History.vue?vue&type=script&lang=ts&"
export * from "./History.vue?vue&type=script&lang=ts&"
import style0 from "@/logs.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./History.vue?vue&type=style&index=1&id=cb49dff8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb49dff8",
  null
  
)

export default component.exports